/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
export var BACKSPACE = 8;
export var TAB = 9;
export var ENTER = 13;
export var SHIFT = 16;
export var ESCAPE = 27;
export var SPACE = 32;
export var ARROW_LEFT = 37;
export var ARROW_UP = 38;
export var ARROW_RIGHT = 39;
export var ARROW_DOWN = 40;
export var DELETE = 46;
